/**
 * Propally Agent API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The AgentV1AssessmentProposalsPost422Response model module.
 * @module model/AgentV1AssessmentProposalsPost422Response
 * @version 1.0.0
 */
class AgentV1AssessmentProposalsPost422Response {
    /**
     * Constructs a new <code>AgentV1AssessmentProposalsPost422Response</code>.
     * @alias module:model/AgentV1AssessmentProposalsPost422Response
     */
    constructor() { 
        
        AgentV1AssessmentProposalsPost422Response.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>AgentV1AssessmentProposalsPost422Response</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/AgentV1AssessmentProposalsPost422Response} obj Optional instance to populate.
     * @return {module:model/AgentV1AssessmentProposalsPost422Response} The populated <code>AgentV1AssessmentProposalsPost422Response</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new AgentV1AssessmentProposalsPost422Response();

            if (data.hasOwnProperty('message')) {
                obj['message'] = ApiClient.convertToType(data['message'], 'String');
            }
            if (data.hasOwnProperty('errors')) {
                obj['errors'] = ApiClient.convertToType(data['errors'], ['String']);
            }
            if (data.hasOwnProperty('code')) {
                obj['code'] = ApiClient.convertToType(data['code'], 'String');
            }
            if (data.hasOwnProperty('matched_by')) {
                obj['matched_by'] = ApiClient.convertToType(data['matched_by'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>AgentV1AssessmentProposalsPost422Response</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>AgentV1AssessmentProposalsPost422Response</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['message'] && !(typeof data['message'] === 'string' || data['message'] instanceof String)) {
            throw new Error("Expected the field `message` to be a primitive type in the JSON string but got " + data['message']);
        }
        // ensure the json data is an array
        if (!Array.isArray(data['errors'])) {
            throw new Error("Expected the field `errors` to be an array in the JSON data but got " + data['errors']);
        }
        // ensure the json data is a string
        if (data['code'] && !(typeof data['code'] === 'string' || data['code'] instanceof String)) {
            throw new Error("Expected the field `code` to be a primitive type in the JSON string but got " + data['code']);
        }
        // ensure the json data is a string
        if (data['matched_by'] && !(typeof data['matched_by'] === 'string' || data['matched_by'] instanceof String)) {
            throw new Error("Expected the field `matched_by` to be a primitive type in the JSON string but got " + data['matched_by']);
        }

        return true;
    }


}



/**
 * @member {String} message
 */
AgentV1AssessmentProposalsPost422Response.prototype['message'] = undefined;

/**
 * @member {Array.<String>} errors
 */
AgentV1AssessmentProposalsPost422Response.prototype['errors'] = undefined;

/**
 * @member {String} code
 */
AgentV1AssessmentProposalsPost422Response.prototype['code'] = undefined;

/**
 * code が COMPANY_ALREADY_MATCHED のとき、本人が既にマッチ済み(self)か同じ会社の別プランナーがマッチ済み(colleague)か
 * @member {module:model/AgentV1AssessmentProposalsPost422Response.MatchedByEnum} matched_by
 */
AgentV1AssessmentProposalsPost422Response.prototype['matched_by'] = undefined;





/**
 * Allowed values for the <code>matched_by</code> property.
 * @enum {String}
 * @readonly
 */
AgentV1AssessmentProposalsPost422Response['MatchedByEnum'] = {

    /**
     * value: "self"
     * @const
     */
    "self": "self",

    /**
     * value: "colleague"
     * @const
     */
    "colleague": "colleague"
};



export default AgentV1AssessmentProposalsPost422Response;

